import { GenericLookupType } from 'src/core/decorators/generic-lookup/generic-lookup-type.decorator';
import { GenericLookup } from 'src/core/decorators/generic-lookup/generic-lookup.decorator';

@GenericLookupType({
  code: 'Insight.Type',
})
export class InsightType {
  @GenericLookup({
    code: 'Insight.Type.Topic',
  })
  static topic: number;

  @GenericLookup({
    code: 'Insight.Type.Summary',
  })
  static summary: number;

  @GenericLookup({
    code: 'Insight.Type.ConversationResult',
  })
  static conversationResult: number;

  @GenericLookup({
    code: 'Insight.Type.NonResolutionRisk',
  })
  static nonResolutionRisk: number;

  @GenericLookup({
    code: 'Insight.Type.Actions',
  })
  static actions: number;

  @GenericLookup({
    code: 'Insight.Type.ChurnRisk',
  })
  static churnRisk: number;
}
